module.exports = __webpack_public_path__ + "img/recon.564f033b.svg";